import React from 'react';

import './FooterPlaceholder.less';

export default function FooterPlaceholder() {
    return <div className={'FooterPlaceholder'} />;
}
